import { Injectable } from '@angular/core';
import { SupportedLanguage } from '../types/lang.type';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private readonly storage: Storage | null;

  constructor() {
    this.storage = typeof window !== 'undefined' ? window.localStorage : null;
  }

  setItem(key: string, value: string): void {
    this.storage?.setItem(key, value);
  }

  getItem(key: string): string | null {
    return this.storage?.getItem(key) ?? null;
  }

  removeItem(key: string): void {
    this.storage?.removeItem(key);
  }

  setLanguage(lang: SupportedLanguage): void {
    this.setItem('preferredLanguage', lang);
  }

  getLanguage(orDefault: boolean = false): string | null {
    return this.getItem('preferredLanguage') || (orDefault ? 'en' : null);
  }
}
